export const baseApiUrl = 'http://localhost:4004'